// NOTE: Taken from web repo.
import { forEach, pick, isEmpty } from 'lodash';

const LOCATION_PARAMS = ['locality', 'region', 'country', 'geo'];
const ALLOWED_PARAM_FIELDS = ['long', 'short', 'lat', 'lng'];
const ALLOWED_FIELDS = ['id', 'name', 'address', 'postcode'];

export const sanitizeLocation = (locationObject) => {
  if (!locationObject) {
    return locationObject;
  }
  // Use sanitizeLocation to safely mutate location objects
  // This function filters out any fields/attributes that aren't defined in namedLocationInputType
  const params = {};

  const fields = pick(locationObject, ALLOWED_FIELDS);
  forEach(fields, (value, fieldName) => {
    if (value) params[fieldName] = value;
  });

  LOCATION_PARAMS.forEach((param) => {
    if (!isEmpty(locationObject[param])) {
      params[param] = pick(locationObject[param], ALLOWED_PARAM_FIELDS);
    }
  });
  return params;
};
